export default {
    tableModal: false,
    selectedSection: null,
    table: null,
    finalTable: null,
    managementToken: null,
    managementUser: null,
    itemId: null,
    photosModel: false,
    profile: null,
    algorithm: null
}